import { createEffect } from 'effector';

import {
  LocationSubscriptionPayload,
  LocationSubscriptionPlan,
  SubscriptionPlanCreateForm,
} from '@m/types/api';
import { apiFetch } from '@m/utils/http';

export const getSubscriptionPlanById = createEffect({
  handler: (subscriptionPlanId: number) =>
    apiFetch(`/admin/subscription/plan/${subscriptionPlanId}`),
});

export const getLocationSubscriptionPlans = createEffect({
  handler: ({ siteId }: { siteId: number }) => apiFetch(`/admin/subscription/plans/site/${siteId}`),
});

export const createLocationSubscriptionPlan = createEffect({
  handler: async ({
    siteId,
    subscriptionPlan,
  }: {
    siteId: number;
    subscriptionPlan: LocationSubscriptionPayload;
  }) =>
    apiFetch(`/admin/subscription/plan/site/${siteId}`, {
      method: 'POST',
      body: subscriptionPlan,
    }),
});

export const createSubscriptionPlanV2 = createEffect({
  handler: async ({
    siteId,
    subscriptionPlanCreateForm,
  }: {
    siteId: number;
    subscriptionPlanCreateForm: SubscriptionPlanCreateForm;
  }) =>
    apiFetch<LocationSubscriptionPlan>(`/v2/admin/subscription/plan/site/${siteId}`, {
      method: 'POST',
      body: subscriptionPlanCreateForm,
    }),
});

export const updateSubscriptionPlan = createEffect({
  handler: ({
    subscriptionPlanId,
    subscriptionPlan,
  }: {
    subscriptionPlan: LocationSubscriptionPayload;
    subscriptionPlanId: number;
  }) =>
    apiFetch(`/admin/subscription/plan/${subscriptionPlanId}`, {
      method: 'PUT',
      body: subscriptionPlan,
    }),
});

export const deleteSubscriptionPlan = createEffect({
  handler: ({ subscriptionPlanId }: { subscriptionPlanId: number }) =>
    apiFetch(`/admin/subscription/plan/${subscriptionPlanId}`, {
      method: 'DELETE',
    }),
});
